import { useTranslation } from 'react-i18next';
import { Element } from 'react-scroll';

import { features } from './data';
import BG from "src/assets/images/home/features/bg.webp";
import Title from '../../../components/title/Title';

export default function Features() {
    const { t, i18n } = useTranslation("home");
    const currentLang: 'ar' | 'en' = i18n.language.includes("ar") ? 'ar' : 'en';

    return (
        <Element
            name="features"
            className="relative isolate overflow-hidden bg-cover bg-center bg-no-repeat py-20 sm:py-24 lg:bg-fixed lg:py-28"
            style={{ backgroundImage: `url(${BG})` }}
        >
            {/* overlay */}
            <div aria-hidden className="absolute inset-0 -z-10 bg-gradient-to-br from-primary-600/80 via-primary-700/80 to-primary-900/90" />
            <div aria-hidden className="bg-dots absolute inset-0 -z-10 text-white/[0.07]" />

            <div className="container">
                <div data-aos="fade-up">
                    <Title
                        lgTitle={t("features.title")}
                        smTitle={t("features.sub_title")}
                        smTitleColor={"#c5e4ffff"}
                    />
                </div>

                <div className="mt-12 grid grid-cols-1 gap-6 sm:mt-14 md:grid-cols-2 lg:grid-cols-3">
                    {features.map((item, index) => (
                        <div
                            key={`feature-key-${index}`}
                            data-aos="fade-up"
                            data-aos-delay={index * 80}
                            className={`group relative flex h-full flex-col items-center overflow-hidden rounded-3xl bg-white px-6 pb-10 pt-12 text-center shadow-[0_20px_50px_-20px_rgba(6,33,63,.5)] transition-all duration-300 hover:-translate-y-2.5 sm:px-8 ${index === features.length - 1 ? "md:col-span-2 md:mx-auto md:max-w-[calc(50%-0.75rem)] lg:col-span-1 lg:max-w-none" : ""}`}
                        >
                            {/* corner glow */}
                            <div aria-hidden className="absolute -end-16 -top-16 h-40 w-40 rounded-full bg-primary-50 transition-transform duration-500 group-hover:scale-150" />

                            <div className="relative mb-7">
                                <div aria-hidden className="absolute inset-0 scale-125 rounded-full bg-primary-100/60 transition-transform duration-500 group-hover:scale-150 group-hover:opacity-0" />
                                <div className="relative grid h-24 w-24 place-items-center rounded-full bg-gradient-to-br from-primary-400 to-dark-primary-500 text-white shadow-glow transition-transform duration-500 group-hover:rotate-[8deg] group-hover:scale-105">
                                    <item.icon className="h-11 w-11" strokeWidth={1.4} />
                                </div>
                            </div>

                            <h4 className="relative mb-3 text-xl font-medium tracking-brand text-gray-900 sm:text-[1.375rem]">
                                {item.title[currentLang]}
                            </h4>
                            <p className="global-p relative !leading-loose">{item.content[currentLang]}</p>
                        </div>
                    ))}
                </div>
            </div>
        </Element>
    );
}
